import React, { useState } from 'react';
import type { KeyboardEvent } from 'react';
import SPASelect from '../../shared/SPASelect';

interface YearOption {
  label: string;
  value: string;
}

const toOption = (year: string): YearOption => ({ label: year, value: year });

interface CopyrightYearsInputProps {
  id: string;
  value: string[];
  onChange: (years: string[]) => void;
}

// A tag input for the additional copyright years: type a year, Enter or Tab adds it. The SPA face
// of admin/ProgramCopyrightSelector, which the legacy form keeps.
const CopyrightYearsInput = ({ id, value, onChange }: CopyrightYearsInputProps) => {
  const [inputValue, setInputValue] = useState('');

  const addYear = (event: KeyboardEvent<HTMLDivElement>) => {
    const year = inputValue.trim();
    if (!year || !['Enter', 'Tab'].includes(event.key)) return;

    event.preventDefault();
    if (!value.includes(year)) onChange([...value, year]);
    setInputValue('');
  };

  return (
    <SPASelect<YearOption, true>
      isMulti
      components={{ DropdownIndicator: null }}
      inputId={id}
      inputValue={inputValue}
      menuIsOpen={false}
      options={[]}
      placeholder="Type a year and press Enter"
      value={value.map(toOption)}
      onChange={next => onChange(next.map(option => option.value))}
      onInputChange={setInputValue}
      onKeyDown={addYear}
    />
  );
};

export default CopyrightYearsInput;
